import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class FutureHistoryTradeService {
  public customerApi: string;
  tradeModification: string;
  tradeStatus: string;
  constructor(private http: HttpClient) {
    this.customerApi = environment.customerApiUrl;
  }

  public getHistoryChartData(body: any): Observable<any> {
    return this.http.post(`${this.customerApi}/Trade/get-trade-history-char`, body);
  }
  public getFutureChartData(body): Observable<any> {
    return this.http.post(`${this.customerApi}/trade/get-trade-future-char`, body);
  }
}
